import nanoid from 'nanoid';
import {api} from "./api";
import {onINP} from 'web-vitals/attribution';
import Cookies from 'js-cookie';
import 'promise-polyfill/src/polyfill';

if (!Array.prototype.forEach) {
    Array.prototype.forEach = function (callback, thisArg) {
        var T, k;

        if (this == null) {
          throw new TypeError(' this is null or not defined');
        }

        // 1. Положим O равным результату вызова ToObject passing the |this| value as the argument.
        var O = Object(this);

        // 2. Положим lenValue равным результату вызова внутреннего метода Get объекта O с аргументом "length".
        // 3. Положим len равным ToUint32(lenValue).
        var len = O.length >>> 0;

        // 4. Если IsCallable(callback) равен false, выкинем исключение TypeError.
        // Смотрите: http://es5.github.com/#x9.11
        if (typeof callback !== 'function') {
            throw new TypeError(callback + ' is not a function');
        }

        // 5. Если thisArg присутствует, положим T равным thisArg; иначе положим T равным undefined.
        if (arguments.length > 1) {
          T = thisArg;
        }

        // 6. Положим k равным 0
        k = 0;

        // 7. Пока k < len, будем повторять
        while (k < len) {
            var kValue;
            // a. Положим Pk равным ToString(k).
            //   Это неявное преобразование для левостороннего операнда в операторе in
            // b. Положим kPresent равным результату вызова внутреннего метода HasProperty объекта O с аргументом Pk.
            //   Этот шаг может быть объединён с шагом c
            // c. Если kPresent равен true, то
            if (k in O) {

              // i. Положим kValue равным результату вызова внутреннего метода Get объекта O с аргументом Pk.
                kValue = O[k];

                // ii. Вызовем внутренний метод Call функции callback с объектом T в качестве значения this и
                // списком аргументов, содержащим kValue, k и O.
                callback.call(T, kValue, k, O);
            }
            // d. Увеличим k на 1.
            k++;
        }
        // 8. Вернём undefined.
    };
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach;
}

function setNanoId() {
    const nanoId = localStorage.getItem('nanoId');
    if (nanoId) return;
    localStorage.setItem('nanoId', nanoid());
}

function initLoad() {
    initDataGoals();
    initAnchorScroll();
}

function initDataGoals() {
    let goalElements = document.querySelectorAll('[data-goal]');
    for (let i = 0; i < goalElements.length; i++) {
        goalElements[i].addEventListener('click', function() {
            let event = new CustomEvent('pushGoal', { detail: {'goal': this.dataset.goal }});
            document.dispatchEvent(event);
            return true;
        });
    }
}

function initGoals() {
    document.addEventListener('pushGoal', function(event) {
        const goal = event.detail.goal;
        try {
            ym(process.env.YANDEX_COUNTER_ID, 'reachGoal', goal);
        } catch(e) {
            console.log('YM error');
        }
        try {
            gtag('event', goal);
        } catch(e) {
            console.log('GA error');
        }
    });
}

function checkFirstVisit() {
    let firstVisitDate = Cookies.get('fv_date');
    if (!firstVisitDate) {
        let visitDate = new Date().toUTCString();

        Cookies.set('fv_date', visitDate, {expires: 365, domain: process.env.COOKIE_DOMAIN, secure: true});

        if (document.referrer) {
            Cookies.set('fv_refer', document.referrer, {expires: 365, domain: process.env.COOKIE_DOMAIN, secure: true});
        }

        Cookies.set('fv_location', location.href, {expires: 365, domain: process.env.COOKIE_DOMAIN, secure: true});
    }
}

function initAnchorScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
        const element = document.querySelector(anchor.getAttribute('href'));
        if (!element) {
            return;
        }
        anchor.addEventListener('click', function (e) {
            const element = document.querySelector(e.currentTarget.getAttribute('href'));
            e.preventDefault();
            const yOffset = -document.querySelector('#header').offsetHeight;
            const y = element.getBoundingClientRect().top + window.pageYOffset + yOffset - 30;

            window.scrollTo({top: y, behavior: 'smooth'});
        });
    });
}

function getUrlParameter(name) {
    name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
    var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
    var results = regex.exec(location.search);
    return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
}

function initReferal() {
    let referal = getUrlParameter('invite');

    if (referal && referal.length < 50) {
        Cookies.set('invite_code', referal, {expires: 30, domain: process.env.COOKIE_DOMAIN, secure: true});
    }
}

function initApiGoals() {
    document.addEventListener('pushApiGoal', function(event) {
        let goal = event.detail.goal;

        api.post('/clicks/addStat', {type: goal});
    });
}

function initGuid() {
    let guid = getUrlParameter('guid');

    if (guid && guid.length < 50) {
        location = process.env.API_URL + '/order/referral?guid=' + guid;
    }
}

function initToTopButton() {
    let toTopButton = document.createElement('button');
    toTopButton.classList.add('button', 'button-totop');
    toTopButton.setAttribute('id', 'button-totop');

    toTopButton.addEventListener('click', () => {
        window.scrollTo({top: 0, behavior: 'smooth'});
    });

    document.body.appendChild(toTopButton);

    window.addEventListener('scroll', () => {
        let scrolled = window.pageYOffset || document.documentElement.scrollTop;
        let clientHeight = window.innerHeight;

        if (scrolled >= clientHeight / 2) {
            toTopButton.classList.add('active');
        } else {
            toTopButton.classList.remove('active');
        }
    });
}

function checkOneTimeKey() {
    let oneTimeKey = getUrlParameter('otk');

    if (oneTimeKey) {
        Cookies.remove('user_token', {domain: process.env.COOKIE_DOMAIN});
        localStorage.setItem('callback_url', location.pathname);
        location = '/user/login?one_time_key=' + oneTimeKey;
    }
}

function hidePreloader() {
    if (document.querySelector('.page-preloader')) {
        setTimeout(() => {
            document.querySelector('.page-preloader').style.display = 'none';
        }, 10000);
    }
}

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register('/sw.js')
    .then(function(reg){
        
    }).catch(function(err) {
        console.log("serviceWorker error:", err);
    });
}

window.appendCss = function (href) {
    var css = document.createElement("link");
    css.rel = "stylesheet";
    css.href = href;
    document.head.appendChild(css);
}

window.appendJs = function (src) {
    var js = document.createElement("script");
    js.type = "text/javascript";
    js.src = src;
    document.head.appendChild(js);
}

window.addEventListener('load', initLoad);

function sendToGoogleAnalytics({name, value, id, attribution}) {
    const {eventEntry, eventTarget, eventType, loadState} = attribution;

    const {startTime, processingStart, processingEnd, duration, interactionId} = eventEntry;

    const eventParams = {
        value: value,
        metric_inp_value: value,
        metric_id: id,
        metric_inp_event_target: eventTarget,
        metric_inp_event_type: eventType,
        metric_inp_load_state: loadState,
        metric_inp_start_time: startTime,
        metric_inp_processing_start: processingStart,
        metric_inp_processing_end: processingEnd,
        metric_inp_duration: duration,
        metric_inp_interaction_id: interactionId
    };

    try {
        gtag('event', name, eventParams);
    } catch(e) {
        console.log('gtag INP error');
    }
}

onINP(sendToGoogleAnalytics);

setNanoId();
initGoals();
initApiGoals();
checkFirstVisit();
initReferal();
initGuid();
initToTopButton();
checkOneTimeKey();
hidePreloader();